var $d9ab5c2611e0bcd3$exports = {};
$d9ab5c2611e0bcd3$exports = {
    "alpha": `Alfa`,
    "blue": `Niebieski`,
    "brightness": `Jasno\u{15B}\u{107}`,
    "green": `Zielony`,
    "hue": `Odcie\u{144}`,
    "lightness": `Jaskrawo\u{15B}\u{107}`,
    "red": `Czerwony`,
    "saturation": `Nasycenie`
};


export {$d9ab5c2611e0bcd3$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
